import { useNavigate } from 'react-router-dom';
import { ShieldAlert, X } from 'lucide-react';
import { AnimatePresence, motion } from 'framer-motion';

export default function CompleteProfileModal({ isOpen, onClose }) {
  const navigate = useNavigate();

  if (!isOpen) return null;

  const handleNavigate = () => {
    onClose();
    navigate('/artisan/settings?tab=verification');
  };

  return (
    <AnimatePresence>
      <div className="fixed inset-0 z-50 flex items-center justify-center px-4 bg-black/60 backdrop-blur-sm">
        <motion.div
          initial={{ opacity: 0, scale: 0.95, y: 10 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          exit={{ opacity: 0, scale: 0.95, y: 10 }}
          className="bg-white max-w-md w-full rounded-3xl shadow-xl overflow-hidden relative"
        >
          <button 
            onClick={onClose}
            className="absolute top-4 right-4 p-2 rounded-full hover:bg-gray-100 transition text-gray-400 hover:text-gray-900 z-10"
          >
            <X size={20} />
          </button>
          
          <div className="p-6 sm:p-8 flex flex-col items-center justify-center text-center">
            <div className="w-16 h-16 sm:w-20 sm:h-20 bg-amber-100 text-amber-500 rounded-full flex items-center justify-center mb-4 sm:mb-6 shadow-sm border border-amber-200">
              <ShieldAlert size={32} className="sm:size-10" />
            </div>
            <h2 className="text-xl sm:text-2xl font-bold text-gray-900 mb-2">Complete Your Profile</h2>
            <p className="text-gray-500 text-xs sm:text-sm leading-relaxed mb-6">
              To build trust globally, all artisans must verify their identity and trade. Please upload a valid Government ID and your Practice/Trade License Certificate to start accepting clients!
            </p>

            <button 
              onClick={handleNavigate}
              className="w-full py-3 sm:py-3.5 bg-black text-white font-semibold rounded-xl sm:rounded-2xl hover:bg-gray-900 transition-colors shadow-lg active:scale-95 text-sm sm:text-base"
            >
              Upload Documents
            </button>
            <button
               onClick={onClose}
               className="mt-4 text-[13px] sm:text-sm font-semibold text-gray-500 hover:text-gray-900 transition-colors"
            >
               I'll do this later
            </button>
          </div>
        </motion.div>
      </div>
    </AnimatePresence>
  );
}
